export default "__VITE_ASSET__DDLZdXg7__"